import React from 'react';
function Button({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect x="2.65" y="8.65" width="18.7" height="6.7" rx="1.35" />
      <path d="M8 12H16" strokeLinecap="round" />
    </svg>
  );
}

export default Button;
